import {
    Component,
    HostListener,
    inject,
    OnInit,
    PLATFORM_ID,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { SeoService } from '@services/seo/seo.service';
import { GoogleAnalyticsService } from '@services/analytics/google-analytics.service';
import { SmoothScrollService } from '@services/global/smooth-scroll.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        HeaderComponent,
        FooterComponent,
        TranslateModule,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
    isSticky: boolean = false;
    showScroll: boolean = false;
    showScrollHeight = 300;
    hideScrollHeight = 10;

    private smoothScrollService = inject(SmoothScrollService);
    readonly #seoService = inject(SeoService);
    readonly #analyticsService = inject(GoogleAnalyticsService);
    private router = inject(Router);
    private hasScrolledToBottom = false;

    constructor() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                this.hasScrolledToBottom = false;
            });
    }

    ngOnInit(): void {
        this.smoothScrollService.init();
    }

    @HostListener('window:scroll')
    checkScroll() {
        const scrollPosition =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;

        if (scrollPosition >= this.showScrollHeight) {
            this.showScroll = true;
        } else {
            this.showScroll = false;
        }

        this.isSticky = window.pageYOffset > 0;

        // Track scroll to bottom
        if (
            !this.hasScrolledToBottom &&
            window.innerHeight + scrollPosition >=
                document.body.offsetHeight - 10
        ) {
            // -10 buffer
            this.hasScrolledToBottom = true;
            this.#analyticsService.sendEvent('scrolledUsers', {
                page_url: this.router.url,
            });
        }
    }

    scrollToTop() {
        this.smoothScrollService.scrollTo(0);
    }
}
